import { render, staticRenderFns } from "./ControlSliders.vue?vue&type=template&id=3712794f&"
import script from "./ControlSliders.vue?vue&type=script&lang=js&"
export * from "./ControlSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports